// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"Cookies--heading_wrapper--2Irpr","bold":"Cookies--bold--22m8E","wordwrap":"Cookies--wordwrap--3uKBm","body_wrapper":"Cookies--body_wrapper--3qhtR"};